import {EntityContact} from "./EntityContact.jsx";
import {STORE_KEYS} from "../../other/constants/StoreKeys.jsx";

export class UserContact extends EntityContact {
  static get $name() {
    return "UserContact";
  }

  static relations = {
    userRecord: { // this will get user record of this record
      foreignKey: "userId",
      foreignStore: STORE_KEYS.boardUserStore,
      relatedCollectionName: "contacts", // this key will be added to the parent to get child records -> userStore.first.contacts will bring all userContact records for that user record
    },
    contactRecord: { // this will get contact (detail) record of this record
      foreignKey: "contactId",
      foreignStore: STORE_KEYS.contactStore,
      relatedCollectionName: "userContacts", // this key will be added to the parent to get child records -> contactStore.first.userContacts will bring all userContact records for that contact record
    }
  }

  static get fields() {
    return [
      { name: "userId", dataSource: "board_user" },
    ];
  }
}

UserContact.exposeProperties();
